import React, { useState } from 'react';
import styled from 'styled-components';

const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
`;

const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-left: 5px solid;
  border-image-source: linear-gradient(180deg, #11b1d8 0%, #0779af 100%);
  border-image-slice: 1;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
  width: 100%;
  background-color: white;
  z-index: ${({ primaryHeader }) => (primaryHeader ? 1 : 0)};
  margin-top: ${({ primaryHeader }) => (primaryHeader ? '0px' : '15px')};
`;

const PanelTitle = styled.h3`
  margin: auto 12px;
  font-weight: normal;
  font-size: 16px;
  display: flex;
  align-items: center;
  height: 40px;
`;

const ToggleButton = styled.div`
  height: 18px;
  width: 18px;
  border: 1px solid black;
  border-radius: 1.64px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  margin: auto 18px;
  color: white;
  background-color: #061e37;

  :hover {
    cursor: pointer;
  }
`;

const PanelChildren = styled.div`
  display: flex;
  flex-direction: column;
`;

const Panel = ({ title, primaryHeader, children, collapsed }) => {
  const [isOpen, setIsOpen] = useState(collapsed ? false : true);

  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <StyledPanel>
      <PanelHeader primaryHeader={primaryHeader}>
        <PanelTitle>{title}</PanelTitle>
        {!primaryHeader && (
          <ToggleButton onClick={togglePanel}>
            {isOpen ? '-' : '+'}
          </ToggleButton>
        )}
      </PanelHeader>
      {isOpen && <PanelChildren>{children}</PanelChildren>}
    </StyledPanel>
  );
};

export default Panel;
